import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context';
import { ToastProvider, LoadingSpinner } from './components/common';
import { 
  Navigation, 
  ProtectedRoute, 
  PublicRoute,
  UserList
} from './components';
import { ReportTab, ReportGenerationPage, ReportEditPage } from './components/report';
import { RegisterPage, LoginPage, UserDashboardPage } from './pages';
import TokenUsagePage from './pages/TokenUsagePage';
import ReportUsagePage from './pages/ReportUsagePage';

import './App.css';
import './styles/page-layout.css';

// Admin Panel component with UserList
const AdminPanel = () => {
  return (
    <section className="admin-panel" aria-labelledby="admin-panel-title">
      <h1 id="admin-panel-title" className="sr-only">관리자 패널</h1>
      <UserList />
    </section>
  );
};

// Main App component that uses AuthContext
function AppContent() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="app-loading" role="status" aria-live="polite">
        <LoadingSpinner size="lg" variant="primary" text="로딩 중..." />
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        {/* Skip to main content link for keyboard navigation */}
        <a href="#main-content" className="skip-link">
          메인 콘텐츠로 건너뛰기
        </a>
        
        <header className="App-header" role="banner">
          <h1 className="sr-only">AWS 사용자 관리 시스템</h1>
        </header>
        
        <Navigation />
        
        <main id="main-content" role="main" tabIndex="-1">
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route 
              path="/login" 
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              } 
            />
            <Route 
              path="/register" 
              element={
                <PublicRoute>
                  <RegisterPage />
                </PublicRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <UserDashboardPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminPanel />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/report" 
              element={
                <ProtectedRoute requireApproved={true}>
                  <ReportTab />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/report/generate" 
              element={
                <ProtectedRoute requireApproved={true}>
                  <ReportGenerationPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/report/edit/:reportId" 
              element={
                <ProtectedRoute requireApproved={true}>
                  <ReportEditPage />
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/token-usage" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <TokenUsagePage />
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/report-usage" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <ReportUsagePage />
                </ProtectedRoute>
              } 
            />

          </Routes>
        </main>
      </div>
    </Router>
  );
}

// Root App component with AuthProvider and InspectionProvider
function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;